import { IconButton } from '@mui/material';
import React from 'react';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import { ReactComponent as CardIcon } from '../../../assets/icons/card-download.svg';
import { ReactComponent as RgzIcon } from '../../../assets/icons/dashboard-rgz.svg';
import { ReactComponent as ExaminersBlockedIcon } from '../../../assets/icons/dashboard-examiners-blocked.svg';
import { ReactComponent as ExaminerBlockedIcon } from '../../../assets/icons/dashboard-single-examiner-blocked.svg';
import { ReactComponent as MultiplePzeBlockedIcon } from '../../../assets/icons/dashboard-PZEs-blocked.svg';
import { ReactComponent as PzeBlockedIcon } from '../../../assets/icons/dashboard-PZE-blocked.svg';
import { ReactComponent as SpecialCaseNotification } from '../../../assets/icons/special-case-notification.svg';
import { useStyles } from '../Dashboard.styles';
import { fillRed } from '../../../utils/contrastSvgAttributes';

interface DashboardNotificationProps {
  pzeBlocked: number;
  examinersBlocked: number;
  isSpecialCase?: boolean;
  isRgzToBeDownloaded: boolean;
  isRgzNotSent: boolean;
}

export const DashboardNotifications: React.FC<DashboardNotificationProps> = ({
  pzeBlocked,
  examinersBlocked,
  isSpecialCase,
  isRgzToBeDownloaded,
  isRgzNotSent,
}) => {
  const styles = useStyles();

  const examinerBlockedLabel =
    examinersBlocked > 1 ? `Zablokowani egzaminatorzy (${examinersBlocked})` : 'Zablokowany egzaminator';
  const pzeBlockedLabel = pzeBlocked > 1 ? `Zablokowani PZE (${pzeBlocked})` : 'Zablokowany PZE';
  const specialCaseLabel = 'Szczególny przypadek';
  const rgzToBeDownloadedLabel = 'Nowe RGZ do pobrania';
  const rgzNotSentLabel = 'Nieodesłane RGZ';

  return (
    <div className={styles.itemContainer}>
      {pzeBlocked > 0 && (
        <TooltipOne title={pzeBlockedLabel} placement="top">
          <IconButton
            disableRipple
            className={styles.iconHover}
            aria-label={pzeBlockedLabel}
            style={{ marginLeft: '-4px', marginRight: '6px' }}
            size="small"
          >
            {pzeBlocked > 1 ? (
              <MultiplePzeBlockedIcon style={{ width: '19px', height: '19px' }} />
            ) : (
              <PzeBlockedIcon style={{ width: '21px', height: '21px' }} />
            )}
          </IconButton>
        </TooltipOne>
      )}
      {examinersBlocked > 0 && (
        <TooltipOne title={examinerBlockedLabel} placement="top">
          <IconButton
            disableRipple
            className={styles.iconHover}
            aria-label={examinerBlockedLabel}
            style={{ marginLeft: '-4px', marginRight: '6px' }}
            size="small"
          >
            {examinersBlocked > 1 ? (
              <ExaminersBlockedIcon style={{ width: '19px', height: '19px' }} />
            ) : (
              <ExaminerBlockedIcon style={{ width: '21px', height: '21px' }} />
            )}
          </IconButton>
        </TooltipOne>
      )}
      {isSpecialCase && (
        <TooltipOne title={specialCaseLabel} placement="top">
          <IconButton disableRipple aria-label={specialCaseLabel} className={styles.iconHover} size="small">
            <SpecialCaseNotification style={{ marginLeft: '-4px', marginTop: '-1px', fill: fillRed }} />
          </IconButton>
        </TooltipOne>
      )}
      {isRgzToBeDownloaded && (
        <TooltipOne title={rgzToBeDownloadedLabel} placement="top">
          <IconButton disableRipple aria-label={rgzToBeDownloadedLabel} className={styles.iconHover} size="small">
            <CardIcon style={{ width: '18px', height: '18px' }} />
          </IconButton>
        </TooltipOne>
      )}
      {isRgzNotSent && (
        <TooltipOne title={rgzNotSentLabel} placement="top">
          <IconButton
            disableRipple
            aria-label={rgzNotSentLabel}
            className={styles.iconHover}
            style={{ marginLeft: 4, marginTop: 1 }}
            size="small"
          >
            <RgzIcon />
          </IconButton>
        </TooltipOne>
      )}
    </div>
  );
};
